import React, { useMemo } from 'react';
import { WEEKDAYS, buildMonthCells, occupancyTone, occupancyLegendText, isDateBeforeContractStart } from './calendarMonthCells';
import styles from './Calendar.module.css';

const daysByDateFromInventory = inventory => {
  const map = {};
  ((inventory && inventory.days) || []).forEach(d => {
    if (d && d.date) map[d.date] = d;
  });
  return map;
};

const OccupancyMonthGrid = ({ year, month, inventory, hideOccupancyBefore }) => {
  const daysByDate = useMemo(() => daysByDateFromInventory(inventory), [inventory]);
  const cells = useMemo(() => buildMonthCells(year, month, daysByDate), [year, month, daysByDate]);

  return (
    <div className={styles.calendar}>
      <div className={styles.weekHeader}>
        {WEEKDAYS.map(label => (
          <div key={label} className={label === 'Sun' ? styles.sunHeader : styles.weekday}>
            {label}
          </div>
        ))}
      </div>
      <div className={styles.monthGrid}>
        {cells.map(cell => (
          <div
            key={cell.key}
            className={[
              styles.cell,
              cell.inMonth ? '' : styles.cellMuted,
              cell.isToday ? styles.cellToday : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <div className={styles.dayNum}>{cell.dayNum}</div>
            {cell.inMonth &&
              (isDateBeforeContractStart(cell.date, hideOccupancyBefore) ? (
                <div className={styles.occupancyHidden}>-</div>
              ) : (
                <div
                  className={`${styles.pill} ${styles[`pill_${occupancyTone(cell.booked, cell.total)}`]}`}
                  title={`${cell.booked} Booked / ${cell.total} Availability`}
                >
                  <span>{cell.booked} Booked</span>
                  <span>{cell.total} Avail.</span>
                </div>
              ))}
          </div>
        ))}
      </div>
      {inventory && <div className={styles.legend}>{occupancyLegendText(inventory)}</div>}
    </div>
  );
};

export default OccupancyMonthGrid;
